import React from "react";
import { asArray, asText, coverageChip } from "../briefModel";
import "../../_shared/QokrPrimitives/_qokr-pill.scss";
import "./_brief-table.scss";

// Annual OKR coverage (handoff 34 §4 ④): annual OKR · status · note. On a
// phone every row becomes its own card (see `_brief-table.scss`).
const BriefCoverageTable = ({ rows }) => {
  const list = asArray(rows).filter((row) => row && asText(row.annual_okr));
  if (!list.length) {
    return (
      <div className="scb-empty-state">
        The brief has no annual OKR coverage.
      </div>
    );
  }
  return (
    <div className="qokr-brief-table qokr-brief-table--coverage" role="table">
      <div className="qokr-brief-table__head" role="row">
        <span role="columnheader">Annual OKR</span>
        <span role="columnheader">Status</span>
        <span role="columnheader">Note</span>
      </div>
      {list.map((row, index) => {
        const chip = coverageChip(row.status);
        return (
          <div className="qokr-brief-table__row" role="row" key={index}>
            <span
              className="qokr-brief-table__cell qokr-brief-table__cell--title"
              role="cell"
            >
              {asText(row.annual_okr)}
            </span>
            <span className="qokr-brief-table__cell" role="cell">
              <span className={`qokr-pill qokr-pill--${chip.tone}`}>
                {chip.label}
              </span>
            </span>
            <span
              className="qokr-brief-table__cell qokr-brief-table__cell--note"
              role="cell"
              data-label="Note"
            >
              {asText(row.note)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default BriefCoverageTable;
